(() => {
  // Keep native restoration as a fallback when session storage is unavailable.
  if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
  const field = '__beScrollEntry';
  const entry = () => {
    let id = history.state?.[field];
    if (!id) {
      id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      history.replaceState({ ...history.state, [field]: id }, '', location.href);
    }
    return id;
  };
  const key = () => `be-scroll:${entry()}`;
  let restoring = false;
  let departure = null;
  let stop = () => {};
  const path = el => {
    const parts = [];
    while (el && el !== document.body) {
      if (el.id) { parts.unshift(`#${CSS.escape(el.id)}`); break; }
      const parent = el.parentElement;
      if (!parent) return null;
      parts.unshift(`${el.localName}:nth-child(${Array.prototype.indexOf.call(parent.children, el) + 1})`);
      el = parent;
    }
    return parts.join(' > ');
  };
  const save = () => {
    if (restoring) return;
    try {
      const horizontal = [...document.querySelectorAll('main *, #MainContent *')]
        .filter(el => el.scrollLeft && el.scrollWidth > el.clientWidth)
        .map(el => ({ selector: path(el), x: el.scrollLeft }));
      sessionStorage.setItem(key(), JSON.stringify({ url: location.href, x: scrollX, y: scrollY, horizontal, time: Date.now() }));
    } catch (_) { /* Storage/history restrictions must not break navigation. */ }
  };
  try { entry(); } catch (_) {}
  window.beScrollRestoration = { save };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || (destination.pathname === location.pathname && destination.search === location.search && destination.hash)) return;
    stop();
    save();
    try { departure = { key: key(), value: sessionStorage.getItem(key()) }; } catch (_) {}

  }, true);
  // Do not replace the click snapshot with a position changed by unloading UI.
  window.addEventListener('pagehide', () => {
    if (departure) {
      try { sessionStorage.setItem(departure.key, departure.value); } catch (_) {}
    } else save();
    stop();
  });
  const clearDeparture = () => { departure = null; };
  ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => window.addEventListener(type, clearDeparture, { capture: true, passive: true }));
  window.addEventListener('pageshow', event => {
    stop();
    departure = null;
    if (!event.persisted && performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') return;
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(key()) || 'null'); } catch (_) { return; }
    if (!saved || saved.url !== location.href) return;
    restoring = true;
    let frame;
    const apply = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (!restoring) return;
        const top = Math.min(saved.y, Math.max(0, document.documentElement.scrollHeight - innerHeight));
        if (Math.abs(scrollY - top) > 0.5 || Math.abs(scrollX - saved.x) > 0.5) {
          window.scrollTo({ left: saved.x, top, behavior: 'instant' });
        }
        saved.horizontal.forEach(({ selector, x }) => {
          const el = selector && document.querySelector(selector);
          if (el) el.scrollLeft = x;
        });
      });
    };
    // Observe late product lists, recently viewed cards, images and web fonts.
    const observer = new ResizeObserver(apply);
    observer.observe(document.body);
    document.querySelectorAll('main, main > *, #MainContent > *').forEach(el => observer.observe(el));
    const inputEvents = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    const finish = () => stop();
    const timeout = setTimeout(finish, 10000);
    stop = () => {
      restoring = false;
      observer.disconnect();
      cancelAnimationFrame(frame);
      clearTimeout(timeout);
      inputEvents.forEach(type => window.removeEventListener(type, finish, true));
      window.removeEventListener('scroll', apply);
      document.removeEventListener('load', apply, true);
      document.removeEventListener('be:products-appended', apply);
    };
    inputEvents.forEach(type => window.addEventListener(type, finish, { capture: true, passive: true }));
    // Native restoration may run after pageshow; correct it until user input.
    window.addEventListener('scroll', apply, { passive: true });
    document.addEventListener('load', apply, true);
    document.addEventListener('be:products-appended', apply);
    document.fonts?.ready.then(() => { if (restoring) apply(); });
    apply();
  });
})();
